import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useGroupStore from '../../store/group';
import useUserStore from '../../store/user';

export default function ManagerProtectedRoutes() {
  const user = useUserStore(state => state.user);
  const { group, fetchGroup } = useGroupStore();
  const location = useLocation();
  const [isCheckingGroup, setIsCheckingGroup] = useState(true);

  useEffect(() => {
    const checkGroup = async () => {
      if (user?.isManager) {
        try {
          await fetchGroup();
        } finally {
          setIsCheckingGroup(false);
        }
      } else {
        setIsCheckingGroup(false);
      }
    };

    checkGroup();
  }, [user, fetchGroup]);

  // Show loading while checking group status
  if (isCheckingGroup) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" />
      </div>
    );
  }

  // If not a manager, redirect to user pages
  if (!user?.isManager) {
    return <Navigate to="/profile" replace />;
  }

  // Allow access to group creation page and invitation page
  const allowedPaths = ['/manager/group/create', '/manager/group'];
  if (allowedPaths.includes(location.pathname)) {
    return <Outlet />;
  }

  // If manager has no group, redirect to create group page
  if (!group) {
    return (
      <Navigate to="/manager/group/create" replace state={{ from: location }} />
    );
  }

  return <Outlet />;
}
